@if (products(); as products) {
  @if (shouldShowAsCarousel()) {
    <p-carousel
      [autoplayInterval]="5000"
      [circular]="true"
      [numScroll]="1"
      [numVisible]="3"
      [responsiveOptions]="responsiveOptions()"
      [showIndicators]="false"
      [value]="products">
      <ng-template
        #item
        let-product>
        <app-public-products-for-sale-tile
          [imageAlt]="product.featuredFile.alt"
          [imageSrc]="product.featuredFile.url"
          [slug]="product.slug"
          [name]="product.name"
          [type]="product.type"
          [sales]="product.sales"
          class="px-4" />
      </ng-template>
    </p-carousel>
  } @else {
    <div class="flex w-full justify-center gap-8">
      @for (product of products; track product.id) {
        <div class="basis-full sm:basis-1/3">
          <app-public-products-for-sale-tile
            [imageSrc]="product.featuredFile.url"
            [slug]="product.slug"
            [imageAlt]="product.featuredFile.alt"
            [sales]="product.sales"
            [type]="product.type"
            [name]="product.name" />
        </div>
      }
    </div>
  }
} @else {
  <app-spinner-filled />
}
